export default {
  'Banking/Mortgage': [
    'Analyst',
    'Audit',
    'Banking',
    'Branch Manager',
    'Broker',
    'Credit',
    'General Management',
    'Lending',
    'Mergers/Acquisitions',
    'Senior Management',
    'Teller',
    'Title/Escrow',
    'Underwriter',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Biotech: ['General Management', 'Senior Management', 'Other'].map((item) => ({
    label: item,
    value: item,
  })),
  Business: [
    'Analysis/Research',
    'Fundraising',
    'General Management',
    'Product Management',
    'Professional Services',
    'Senior Management',
    'Services/Support',
    'Strategic Planning/Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Creative/Design': [
    'Advertising',
    'Animation/Multimedia',
    'Creative Direction',
    'General Management',
    'Industrial Design',
    'Senior Management',
    'Web Design',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Customer Support/Client Services': [
    'Account Management',
    'Call/Contact Center',
    'Customer Service/Support',
    'General Management',
    'Product Support',
    'Senior Management',
    'Technical Support',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Education: [
    'Admissions/Advising',
    'Corporate Training',
    'Faculty',
    'General Management',
    'Librarian',
    'Senior Management',
    'Student',
    'Teacher/Professor',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Engineering: [
    'Automotive Engineering',
    'Electrical/Electronics Engineering',
    'Energy/Nuclear Engineering',
    'Enterprise Software Implementation/Consulting',
    'General Management',
    'Industrial/Manufacturing Engineering',
    'Semiconductors',
    'Senior Management',
    'Six Sigma/Black Belt/TQM',
    'System/Process Engineering',
    'Test Engineering',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Executives: [
    'Board Member',
    'CEO',
    'COO/Chief Operations Officer',
    'Chairman',
    'General Manager',
    'Managing Partner',
    'Other CXO',
    'Owner/Co-owner',
    'Partner',
    'President',
    'Principal',
    'Treasurer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Finance/Accounting': [
    'Accounting',
    'Account Payable/Receivable',
    'Analyst',
    'Audit',
    'CFO/Chief Financial Officer',
    'Controller',
    'Corporate',
    'Credit Review/Analysis',
    'Financial Analysis/Research',
    'Financial Control',
    'Financial Planning/Advising',
    'Financial Product Sales/Brokerage',
    'Fund Accounting',
    'General Management',
    'Investment Banking/Sales and Trading',
    'Investment Management',
    'Private Equity',
    'Procurement',
    'Registered Investment Advisor',
    'Risk Management/Compliance',
    'Securities Analysis/Research',
    'Senior Management',
    'Tax Assessment/Collections',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Human Resources': [
    'CHRO/Chief Human Resource Officer',
    'CLO/Chief Learning Officer',
    'CPO/Chief People Officer',
    'Compensation/Benefit Policy',
    'Corporate Communications',
    'Corporate Development',
    'Diversity Management/EEO/Compliance',
    'General Management',
    'HR Systems Administration',
    'Learning/Training',
    'Organizational Development',
    'Payroll/Benefits',
    'Recruiting',
    'Senior Management',
    'Talent Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'IT/Computers/Electronics': [
    'Business Intelligence/Data Science',
    'CDO/Chief Data Officer',
    'CIO/Chief Information Officer',
    'CISO/Chief Information Security Officer',
    'CSO/Chief Security Officer',
    'CTO/Chief Technology Officer',
    'Computer Engineering',
    'Computer/Network Security',
    'Cyber Security/Information Security',
    'Data Center',
    'Database Management',
    'Devops & Application Management',
    'Enterprise Software Implementation',
    'General Management',
    'Hardware',
    'IT Infrastructure',
    'IT Project Management',
    'IT Systems Management',
    'Network/Server Administration',
    'Product Development',
    'QA & Testing',
    'Senior Management',
    'Software Development',
    'Software Engineer',
    'Software/System Architecture',
    'Storage Management',
    'System Admin/Desktop Support',
    'System Analysis',
    'Telecommunications & Wireless',
    'Web Developer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Insurance: [
    'Actuarial Analysis',
    'Audit',
    'Employee Benefits Broker/Consultant',
    'Financial Analysis/Research',
    'General Management',
    'Investment Management',
    'Planning/Advising',
    'Policy Underwriting',
    'Risk Management/Compliance',
    'Senior Management',
    'Third Party Administrator',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Journalism/Media/Entertainment': [
    'Digital Content Development',
    'General Management',
    'Journalism',
    'Public Relations',
    'Radio/Broadcasting',
    'Senior Management',
    'Video/Television',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Legal: [
    'CCO/Chief Compliance Officer',
    'General Management',
    'Labor/Entertainment',
    'Law Firm Attorney',
    'Legal Operations',
    'Litigation',
    'Patent/IP',
    'Real Estate',
    'Regulatory/Compliance',
    'Senior Management',
    'Tax Lawyer',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Logistics/Transportation': [
    'General Management',
    'Inventory Planning/Management',
    'Logistics',
    'Merchandise Planning/Buying',
    'Purchasing',
    'Senior Management',
    'Supply Chain Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Manufacturing/Production/Operations': [
    'General Management',
    'Machining/CNC',
    'Materials',
    'Operations',
    'Packaging',
    'Planning/Advising',
    'Scientific/Technical Production',
    'Senior Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Marketing: [
    'Affiliate Marketing',
    'Brand/Product Marketing',
    'Channel Marketing',
    'CMO/Chief Marketing Officer',
    'Content Marketing',
    'Corporate Marketing',
    'Creator/Influencer',
    'Demand/Lead Generation',
    'Digital Marketing',
    'Direct Marketing',
    'Events/Promotional Marketing',
    'Fundraising',
    'General Management',
    'Investor/Public/Media Relations',
    'Market Research',
    'Marketing Communications',
    'Marketing Operations',
    'Marketing Technology',
    'Media Planning/Buying',
    'Product Management',
    'Public Relations',
    'SEO',
    'Senior Management',
    'Social Media',
    'Visual/Display Marketing',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Medical and Health': ['General Management', 'Research', 'Senior Management', 'Other'].map(
    (item) => ({ label: item, value: item })
  ),
  Retail: ['Senior Management', 'eCommerce', 'Other'].map((item) => ({ label: item, value: item })),
  Sales: [
    'Business Development',
    'General Management',
    'Media/Advertising Sales',
    'Product Sales',
    'Sales',
    'Sales Operations',
    'Senior Management',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  'Strategy and Consulting': [
    'HR Consulting',
    'Management Consulting',
    'OPerations Consulting',
    'Strategy',
    'Strategy Consulting',
    'Technology Consulting',
    'Other',
  ].map((item) => ({ label: item, value: item })),
  Other: ['Other'].map((item) => ({ label: item, value: item })),
};
